export default {
  common: {
    search: '搜索鞋子...',
    loading: '加载中...',
    welcome: '欢迎来到潮鞋电商',
    addToCart: '加入购物车',
    buyNow: '立即购买',
    outOfStock: '库存不足',
    viewMore: '查看更多',
    relatedProducts: '相关商品',
    empty: '暂无数据',
    goBack: '返回',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    success: '操作成功',
    error: '操作失败',
  },
  nav: {
    home: '首页',
    products: '所有商品',
    categories: '品类',
    brands: '品牌',
    collections: '系列',
    about: '关于我们',
    contact: '联系我们',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    account: '我的账户',
    cart: '购物车'
  },
  product: {
    price: '价格',
    size: '尺码',
    color: '颜色',
    quantity: '数量',
    description: '商品描述',
    specifications: '商品规格',
    reviews: '商品评价',
    relatedProducts: '相关商品',
    inStock: '有库存',
    outOfStock: '缺货',
    fewLeft: '仅剩少量',
    sale: '特价',
    new: '新品'
  },
  cart: {
    title: '购物车',
    empty: '购物车是空的',
    continueShopping: '继续购物',
    checkout: '结算',
    subtotal: '小计',
    total: '总计',
    shipping: '运费',
    tax: '税费',
    remove: '删除',
    update: '更新'
  },
  footer: {
    customerService: '客户服务',
    helpCenter: '帮助中心',
    company: '公司',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    legal: '法律',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    copyright: '© 2023 潮鞋电商. 版权所有.'
  },
  account: {
    profile: '个人资料',
    orders: '我的订单',
    wishlist: '收藏夹',
    addresses: '收货地址',
    settings: '账户设置',
    changePassword: '修改密码'
  },
  home: {
    banner: {
      title: '探索最新鞋款',
      description: '发现您喜爱的潮流鞋款，展现个性风格',
      button: '浏览所有鞋子'
    },
    intro: {
      title: '关于我们的鞋子相册',
      description1: '这是一个专注于展示潮流鞋款的相册网站，您可以浏览各种品牌的鞋子图片和详情信息。',
      description2: '我们提供高清图片和详尽的商品描述，让您充分了解每一款鞋子的特点和风格。',
      button1: '浏览鞋子列表',
      button2: '按品牌分类浏览'
    },
    featured: {
      title: '精选品牌',
      description: '各大知名品牌的经典款式'
    }
  },
  shoes: {
    title: '鞋子相册',
    searchPlaceholder: '搜索鞋子名称或型号...',
    filterByBrand: '按品牌筛选',
    sortBy: '排序方式',
    sortOptions: {
      newest: '最新添加',
      oldest: '添加时间（从早到晚）',
      nameAsc: '名称 A-Z',
      nameDesc: '名称 Z-A'
    },
    noResults: '没有找到符合条件的鞋子',
    resetFilters: '重置筛选条件',
    viewDetails: '查看详情',
    noModelNumber: '无型号',
    showing: '显示',
    of: '共',
    pairs: '双鞋子',
    page: '第',
    totalPages: '页 / 共',
    pages: '页',
    exclusivePhoto: '独家实拍',
    brand: '品牌'
  },
  collections: {
    title: '品牌分类',
    subtitle: '浏览不同品牌的鞋子',
    error: '获取品牌分类失败',
    retry: '重试',
    empty: '暂无品牌分类数据',
    browse: '浏览鞋子'
  }
} 